import React from 'react';
import Text from 'shared/components/text';
import Icon from 'shared/components/icon';

interface Props {
  relationship: {
    minGPA: number;
  };
}

const BoostGpaText = ({relationship}: Props) => {
  const {minGPA} = relationship;

  return (
    <div className="shared-college-card-status-text-gpa">
      <Icon className="shared-college-card-status-text-warning-flag" iconType="flag" />
      <Text weight={6} inline>
        Boost GPA to {minGPA} to earn
      </Text>
    </div>
  );
};

export default BoostGpaText;
